import es from './es';
import en from './en';
import fr from './fr';
import it from './it';
import ro from './ro';
import pl from './pl';

const resources = {
  es,
  en,
  fr,
  it,
  ro,
  pl,
};

export const config = {
  resources: resources,
};
